import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Upload from "./pages/Upload";
import Photo from "./components/Photo";
import LeafletMap from "./components/LeafletMap";
import Homepage from "./pages/HomePage";
import ProtectedRoute from "./ProtectedRoute";
import MapPage from "./pages/MapPage";
import TimelinePage from "./components/home/AboutUs";
import CommunityPage from "./pages/CommunityPage";


import { UserProvider } from "./contexts/UserContext";
import { ModalProvider } from "./contexts/ModalContext";
import { AlbumProvider } from "./contexts/AlbumContext";

function App() {
  return (
    <UserProvider>
      <AlbumProvider>
        <ModalProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/map" element={<MapPage />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/upload" element={<Upload />} />
                <Route path="/dashboard" element={<Dashboard />} />
              </Route>
              <Route path="/community" element={<CommunityPage />} />
              <Route path="*" element={<LoginPage />} />
            </Routes>
          </Router>
        </ModalProvider>
      </AlbumProvider>
    </UserProvider>
  );
}

export default App;